import { Link } from "react-router-dom";
import { useStore } from "@/context/StoreContext";
import { imgUrl } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Sparkles, ShieldCheck, HeartHandshake, Smile, ArrowRight } from "lucide-react";
import { ContactCTA } from "@/pages/Home";

const VALUES = [
  { icon: Sparkles, title: "Trendy Collections" },
  { icon: ShieldCheck, title: "Premium Quality" },
  { icon: HeartHandshake, title: "Affordable Fashion" },
  { icon: Smile, title: "Happy Customers" },
];

const About = () => {
  const { settings } = useStore();
  return (
    <div data-testid="about-page">
      <section className="bg-blush/40 py-16 text-center">
        <h1 className="font-serif text-5xl text-burgundy">About Us</h1>
        <p className="mt-2 font-script text-3xl text-charcoal/70">Fashion, Comfort & Confidence</p>
      </section>
      <section className="mx-auto max-w-6xl px-6 py-16">
        <div className="grid items-center gap-10 md:grid-cols-2">
          <div>
            <h2 className="font-serif text-3xl text-burgundy">Our Story</h2>
            <span className="mt-3 block h-0.5 w-16 bg-burgundy" />
            <p className="mt-6 leading-relaxed text-charcoal">
              {settings.business_name || "ANUSWA by Unique Cloth"} is more than just a store — it's a celebration of every woman's unique style. Based in {settings.location || "Palanpur, Gujarat"}, we bring together trendy clothing and stylish footwear, offering quality, comfort and elegance all in one place.
            </p>
            <p className="mt-4 leading-relaxed text-charcoal">
              Our goal is to make every woman feel confident, beautiful and special, no matter the occasion. From everyday essentials to festive statement pieces, ANUSWA is your destination for contemporary Indian fashion.
            </p>
            <Button asChild className="mt-6 rounded-none bg-burgundy"><Link to="/new-arrivals">Explore Collection <ArrowRight className="ml-2 h-4 w-4" /></Link></Button>
          </div>
          <img src={imgUrl("https://images.unsplash.com/photo-1567401893414-76b7b1e5a7a5?crop=entropy&cs=srgb&fm=jpg&q=85&w=900")} alt="ANUSWA store" className="h-96 w-full object-cover" />
        </div>
        <div className="mt-16 grid grid-cols-2 gap-6 md:grid-cols-4">
          {VALUES.map((v) => (
            <div key={v.title} className="flex flex-col items-center gap-3 border border-border p-6 text-center">
              <v.icon className="h-8 w-8 text-burgundy" strokeWidth={1.5} />
              <p className="font-medium text-charcoal">{v.title}</p>
            </div>
          ))}
        </div>
      </section>
      <section className="relative overflow-hidden bg-rose/40 py-20 text-center">
        <p className="font-script text-4xl text-burgundy">More Than Fashion</p>
        <h2 className="mt-1 font-serif text-4xl text-charcoal">It's a Lifestyle</h2>
      </section>
      <ContactCTA />
    </div>
  );
};

export default About;
